import { createRegistry } from '../registry.js';
export const automationTriggerRegistry = createRegistry('automation-trigger-registry', (unit) => unit.id);
export const automationConditionRegistry = createRegistry('automation-condition-registry', (unit) => unit.id);
export const automationActionRegistry = createRegistry('automation-action-registry', (unit) => unit.id);
export function defineAutomationTrigger(unit) {
    return unit;
}
export function defineAutomationCondition(unit) {
    return unit;
}
export function defineAutomationAction(unit) {
    return unit;
}
/** Renders a unit's sentence with the recipe's parameter values for the builder/activity screens. */
export function renderSentence(sentence, values, format = (_key, value) => String(value ?? '…')) {
    return sentence.replace(/\{(\w+)\}/g, (_match, key) => key in values ? format(key, values[key]) : `{${key}}`);
}
//# sourceMappingURL=types.js.map